import React from 'react';
import Style from './select.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Select = props => {
  const selectId = `select-${React.useId()}`;
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.label = props.label === undefined ? '' : props.label;
  propsArray.placeholder = props.placeholder === undefined ? '' : props.placeholder;
  propsArray.hint = props.hint === undefined ? '' : props.hint;
  propsArray.init = props.init === undefined ? '' : props.init;
  propsArray.search = props.search === undefined ? false : true;
  propsArray.variant = Style[props.variant === undefined ? 'outlined' : props.variant];
  propsArray.color = Style[props.color === undefined ? 'dark' : props.color];
  propsArray.size = Style[props.size === undefined ? 'md' : props.size];
  propsArray.direction = Style[props.direction === undefined ? 'slideDown' : props.direction];
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  const [option, setOption] = React.useState('');

  const handleValue = event => {
    setOption(event.target.firstElementChild.value.split(',')[1]);
    props.onChange(event.target.firstElementChild.value.split(',')[0]);
    toggle(event);
  };

  const search = event => {
    let input = document.getElementById(selectId).querySelectorAll('input[name=selectItem]');
    input.forEach(obj => {
      obj.closest('li').classList.add('d-none');
    });
    input.forEach(obj => {
      if (obj.value.split(',')[1].indexOf(event.target.value) > -1) {
        obj.closest('li').classList.remove('d-none');
      }
    });
  };

  React.useEffect(() => {
    if (propsArray.init !== '') {
      let init = propsArray.init.toString();
      let input = document.getElementById(selectId).querySelectorAll('input[name=selectItem]');
      input.forEach(obj => {
        if (obj.value.split(',')[0] === init) {
          setOption(obj.value.split(',')[1]);
          props.onChange(init);
        }
      });
    }
  }, [propsArray.init]);

  const toggle = event => {
    if (event.target.closest(`.${Style.body}`).querySelector(`.${Style.wrapper}`).classList.contains('d-none')) {
      event.target.closest(`.${Style.body}`).querySelector(`.${Style.wrapper}`).classList.remove('d-none');
      event.target.closest(`.${Style.body}`).querySelector(`.${Style.wrapper}`).classList.add('d-block');
      event.target.closest(`.${Style.body}`).querySelector(`.${Style.wrapper}`).classList.add(propsArray.direction);
    } else {
      event.target.closest(`.${Style.body}`).querySelector(`.${Style.wrapper}`).classList.remove('d-block');
      event.target.closest(`.${Style.body}`).querySelector(`.${Style.wrapper}`).classList.remove(propsArray.direction);
      event.target.closest(`.${Style.body}`).querySelector(`.${Style.wrapper}`).classList.add('d-none');
    }
  };

  document.addEventListener('click', event => {
    let selectList = document.querySelectorAll(`.${Style.select} .${Style.wrapper}`);

    if (event.target.closest(`.${Style.select}`) === null) {
      for (let i = 0; i < selectList.length; i++) {
        selectList[i].classList.remove('d-block');
        selectList[i].classList.add('d-none');
      }
    }
  });
  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsxs("div", {
      id: selectId,
      className: `${Style.select} ${propsArray.variant} ${propsArray.color}`,
      css: emotionStyle,
      children: [propsArray.label !== '' && _jsx("label", {
        children: props.label
      }), _jsxs("div", {
        className: `${Style.body}`,
        children: [_jsxs("div", {
          children: [_jsx("input", {
            onClick: toggle,
            className: propsArray.size,
            type: "text",
            value: option,
            placeholder: propsArray.placeholder,
            readOnly: true
          }), _jsx("svg", {
            fill: "#5C5B69",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 8 6",
            children: _jsx("path", {
              d: "M4 5.091a.748.748 0 0 1-.531-.219l-3.11-3.11a.5.5 0 0 1 .708-.707l2.932 2.933 2.933-2.933a.5.5 0 0 1 .707.707l-3.11 3.11a.748.748 0 0 1-.53.22Z"
            })
          })]
        }), _jsxs("div", {
          className: `${Style.wrapper} d-none`,
          children: [propsArray.search === true && _jsxs("div", {
            className: `${Style.search}`,
            children: [_jsx("input", {
              onChange: event => search(event),
              placeholder: "\u062C\u0633\u062A\u062C\u0648"
            }), _jsxs("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              stroke: "#5C5B69",
              strokeWidth: "2",
              viewBox: "0 0 24 24",
              children: [_jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
              }), _jsx("path", {
                d: "m21 21-4.35-4.35"
              })]
            })]
          }), _jsx("ul", {
            onClick: handleValue,
            children: props.children
          })]
        })]
      }), propsArray.hint !== '' && _jsx("small", {
        className: `text-${props.color}`,
        children: props.hint
      })]
    }), propsArray.className !== '' && _jsxs("div", {
      id: selectId,
      className: `${Style.select} ${propsArray.variant} ${propsArray.color} ${propsArray.className}`,
      css: emotionStyle,
      children: [propsArray.label !== '' && _jsx("label", {
        children: props.label
      }), _jsxs("div", {
        className: `${Style.body}`,
        children: [_jsxs("div", {
          children: [_jsx("input", {
            onClick: toggle,
            className: propsArray.size,
            type: "text",
            value: option,
            placeholder: propsArray.placeholder,
            readOnly: true
          }), _jsx("svg", {
            fill: "#5C5B69",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 8 6",
            children: _jsx("path", {
              d: "M4 5.091a.748.748 0 0 1-.531-.219l-3.11-3.11a.5.5 0 0 1 .708-.707l2.932 2.933 2.933-2.933a.5.5 0 0 1 .707.707l-3.11 3.11a.748.748 0 0 1-.53.22Z"
            })
          })]
        }), _jsxs("div", {
          className: `${Style.wrapper} d-none`,
          children: [propsArray.search === true && _jsxs("div", {
            className: `${Style.search}`,
            children: [_jsx("input", {
              onChange: event => search(event),
              placeholder: "\u062C\u0633\u062A\u062C\u0648"
            }), _jsxs("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              stroke: "#5C5B69",
              strokeWidth: "2",
              viewBox: "0 0 24 24",
              children: [_jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
              }), _jsx("path", {
                d: "m21 21-4.35-4.35"
              })]
            })]
          }), _jsx("ul", {
            onClick: handleValue,
            children: props.children
          })]
        })]
      }), propsArray.hint !== '' && _jsx("small", {
        className: `text-${props.color}`,
        children: props.hint
      })]
    })]
  });
};

Select.Item = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.value = props.value === undefined ? '' : props.value;
  propsArray.children = props.children === undefined ? '' : props.children;
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("li", {
      css: emotionStyle,
      children: _jsxs("label", {
        children: [_jsx("input", {
          name: "selectItem",
          value: `${props.value}, ${props.children}`,
          type: "hidden",
          readOnly: true
        }), props.children]
      })
    }), propsArray.className !== '' && _jsx("li", {
      className: `${props.className}`,
      css: emotionStyle,
      children: _jsxs("label", {
        children: [_jsx("input", {
          name: "selectItem",
          value: `${props.value}, ${props.children}`,
          type: "hidden",
          readOnly: true
        }), props.children]
      })
    })]
  });
};

export default Select;